<template>
  <md-card class="md-card-plain">
    <md-card-header>
      <h4 class="title">Service Status</h4>
    </md-card-header>
    <md-card-content>
      <template>
        <div>
          <md-table v-model="services">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell>{{ item.name }}</md-table-cell>
              <md-table-cell>
                <div v-if="item.is_running">
                  <md-button class="md-just-icon md-simple md-success">
                    <i class="fa fa-check-circle text-success"></i>
                    <md-tooltip md-direction="top">Active</md-tooltip>
                  </md-button>
                </div>
                <div v-else>
                  <md-button class="md-just-icon md-simple md-danger">
                    <!-- <md-icon>warning</md-icon> -->
                    <i class="fa fa-exclamation-circle text-success"></i>
                    <md-tooltip md-direction="top">Not-active</md-tooltip>
                  </md-button>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </template>
    </md-card-content>
  </md-card>
</template>

<script>
import ApiService from "@/services/ApiService";
export default {
  name: "service-status",
  data() {
    return {
      selected: [],
      services: [
        {
          name: "Database",
          is_running: false
        },
        {
          name: "Salesidol",
          is_running: false
        },
        {
          name: "Mayai",
          is_running: false
        }
      ]
    };
  },
  mounted() {
    this.fetchDBStatus();
    this.fetchSalesidolStatus();
    // this.timer = setInterval(async () => {
    //   await DataService.updateStatus({ uniqueids: this.RunningSchedulesid });
    //   this.RunningSchedulesid.forEach(el => {
    //     this.getFetchStatus(el);
    //   });
    // }, 30000);
  },
  methods: {
    async fetchDBStatus() {
      var responce = await ApiService.fetchDBServiceStatus();
      // console.log(responce);
      if (responce.data) {
        var service = responce.data.service;
        if (service !== "NONE") {
          this.services.forEach(serv => {
            if (serv.name === "Database") {
              if (service.status === "connected") {
                serv.is_running = true;
              } else {
                serv.is_running = false;
              }
            }
          });
        }
      }
    },
    async fetchSalesidolStatus() {
      var responce = await ApiService.fetchSalesidolStatus();
      // console.log(responce);
      if (responce.data) {
        var service = responce.data.service;
        if (service !== "NONE" && service !== "DOWN") {
          this.services.forEach(serv => {
            if (serv.name !== "Database") {
              serv.is_running = true;
            }
          });
        }
      }
    }
  }
};
</script>
